import { Space } from "@mantine/core";
import VisualizarResultadosList from "@/modules/visualizar-resultados-externo/components/visualizarResultados-list";

// prettier-ignore
const VisualizarResultadosExternoPage = () => {
  return (
    <>
      <Space h="md" />
      <VisualizarResultadosList />
    </>
  );
};

VisualizarResultadosExternoPage.displayName = "VisualizarResultadosExternoPage";

export default VisualizarResultadosExternoPage;
